import { render, staticRenderFns } from "./section-info-col-type-personnel.vue?vue&type=template&id=652664b4&scoped=true&"
import script from "./section-info-col-type-personnel.ts?vue&type=script&lang=ts&"
export * from "./section-info-col-type-personnel.ts?vue&type=script&lang=ts&"
import style0 from "./section-info-col-type-personnel.scss?vue&type=style&index=0&id=652664b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652664b4",
  null
  
)

export default component.exports